import React from "react";
import Link from "next/link";

const GetStartedButton: React.FC = () => {
    return (
        <div className="mt-10 sm:flex sm:justify-center lg:justify-start">
            <div className="rounded-md shadow-sm">
                <Link
                    href="/contact"
                    className="rounded-md bg-blue-600 px-6 py-3 text-md font-normal text-white shadow-sm transition-colors hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-400"
                    aria-label="Get started with FullStack Software Labs"
                >
                    Get started
                </Link>
            </div>
        </div>
    );
};

export default GetStartedButton;
